import React, { useState, useRef } from 'lib/react';
import {
  EVButton,
  EVClear,
  EVClickAwayListener,
  EVGrid,
  EVPaper,
  EVPopper,
  EVTypography,
  makeStyles,
} from 'lib/components';
import { SketchPicker } from 'react-color';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';

const useStyles = makeStyles(() => ({
  colorButton: ({ color }) => ({
    backgroundColor: color,
    border: '1px solid black',
    height: '30px',
    width: '93px',
  }),
  colorPicker: {
    boxShadow: 'none !important',
  },
  closeButton: {
    padding: 0,
    minWidth: 'unset',
  },
}));

function ColorPicker(props) {
  const { color, setColor, pillId } = props;

  const classes = useStyles({ color });
  const { t } = useTranslation();

  const [openPicker, setOpenPicker] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonEl = useRef(null);

  const handleOpenPicker = () => {
    setAnchorEl(buttonEl.current);
    setOpenPicker(true);
  };

  const handleClickAway = () => {
    setAnchorEl(null);
    setOpenPicker(false);
  };

  return (
    <div style={{ width: 'fit-content' }} ref={buttonEl}>
      <EVButton
        id={pillId}
        variant="contained"
        color="primary"
        className={classes.colorButton}
        onClick={handleOpenPicker}
      />
      <EVPopper
        placement="bottom-start"
        anchorEl={anchorEl}
        open={openPicker}
        modifiers={{ offset: { offset: '0,8px' } }}
      >
        <EVClickAwayListener onClickAway={handleClickAway}>
          <EVPaper>
            <EVGrid container justifyContent="space-between" alignItems="center" style={{ padding: 8 }}>
              <EVTypography>{t('color_picker_choose_color')}</EVTypography>
              <EVButton
                className={classes.closeButton}
                onClick={handleClickAway}
                id="color-picker-close-btn"
              >
                <EVClear />
              </EVButton>
            </EVGrid>
            <SketchPicker
              color={color}
              onChange={setColor}
              presetColors={['#2E4552', '#4F998F', '#E3C578', '#E7A56C', '#D77659', '#C53A33', '#183D85', '#3375B2', '#4294C3', '#50B1D3', '#6FC7E0']}
              className={classes.colorPicker}
              disableAlpha
            />
          </EVPaper>
        </EVClickAwayListener>
      </EVPopper>
    </div>
  );
}

ColorPicker.defaultProps = {
  pillId: 'color-pill',
};

ColorPicker.propTypes = {
  pillId: PropTypes.string,
  color: PropTypes.string.isRequired,
  setColor: PropTypes.func.isRequired,
};

export default ColorPicker;
